import ReactMarkdown from "react-markdown";

import { MarkdownContent } from "./styles";

interface MarkdownMessageProps {
  content: string;
}

export const MarkdownMessage: React.FC<MarkdownMessageProps> = ({ content }) => {
  return (
    <MarkdownContent>
      <ReactMarkdown>{content}</ReactMarkdown>
    </MarkdownContent>
  );
};
